<template><div><h1>VUX V2.7.2 发布日志</h1>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[feature] 支持作为模块直接调用 (import { AlertModule } from 'vux') #2173</li>
</ul>
<h2><a href="/zh-CN/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] 支持禁用选择属性 prop:readonly #2178</li>
<li>[fix] 修复 on-change 事件重复触发的问题</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] 当指定结束日期但未指定开始日期时使用默认年第一天作为开始日期 #2158</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] 修复多选情况下重置值时没有正确渲染的问题 #2160</li>
<li>[fix] 修复部分属性没有继承 inline-calendar 的问题 #2105</li>
<li>[fix] 修复禁用周末日期仍能点击的问题 #2178</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[feature] 支持 value-map 属性用以自动转换 API 数据 #2139</li>
<li>[feature] 支持 getFullValue 方法获取当中选中值的原始数据</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[feature] 支持阻止自动切换 #2176</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.2-264.vue?10b0a882